(function() {
  const dataSets = {
    10: {
      estimate: [4, 16, 16, 24, 24, 16, 4.571428571428571, 1.1428571428571428, 1.1428571428571428],
      real: [4, 16, 20, 30, 30, 20, 8, 1, 1]
    },
    12: {
      estimate: [4, 8, 16, 32, 19.2, 19.2, 5.485714285714286, 2.742857142857143, 0.9142857142857143, 0.18285714285714286, 0.18285714285714286],
      real: [4, 8, 16, 32, 20, 20, 5, 4, 0, 0, 0]
    },
    14: {
      estimate: [6, 36, 60, 150, 120, 160, 160, 120, 40, 16, 2.90909090909091, 0.484848484848485, 0.484848484848485],
      real: [6, 36, 60, 150, 114, 158, 158, 66, 19, 16, 4, 1, 1]
    },
    16: {
      estimate: [8, 32, 74.66666666666667, 149.33333333333334, 179.2, 179.2, 128, 128, 56.888888888888886, 22.755555555555556, 6.206060606060606, 2.0686868686868687, 0.31825951825951826, 0.045465645465645466, 0.045465645465645466],
      real: [8, 32, 76, 152, 188, 168, 118, 118, 60, 31, 9, 4, 0, 0, 0]
    },
    18: {
      estimate: [6, 36, 72, 180, 180, 360, 205.71428571428572, 205.71428571428572, 205.71428571428572, 123.42857142857143, 33.66233766233766, 16.83116883116883, 2.589410589410589, 0.7398315969744541, 0.14796631939489083, 0.018495789924361353, 0.018495789924361353],
      real: [6, 36, 72, 180, 172, 344, 199, 136, 136, 79, 19, 15, 1, 0, 0, 0, 0]
    },
    20: {
      estimate: [8, 32, 74.66666666666667, 298.6666666666667, 597.3333333333334, 597.3333333333334, 512, 768, 426.6666666666667, 426.6666666666667, 155.15151515151516, 103.43434343434343, 23.86946386946387, 6.81984681984682, 2.2732822732822733, 0.5683205683205683, 0.06686124333183156, 0.007429027036870174, 0.007429027036870174],
      real: [8, 32, 76, 304, 608, 568, 478, 674, 363, 363, 141, 72, 20, 5, 3, 1, 0, 0, 0]
    },
    22: {
      estimate: [10, 100, 300, 1350, 2160, 5760, 5760, 10080, 6720, 8064, 8064, 6720, 2584.61538461538, 1476.92307692308, 393.846153846154, 147.692307692308, 26.0633484162896, 5.79185520361991, 0.609668968802096, 0.06096689688021, 0.06096689688021],
      real: [10, 100, 304, 1368, 2186, 5824, 6165, 9970, 6843, 8026, 8026, 4961, 1922, 1130, 333, 64, 12, 4, 0, 0, 0]
    },
    24: {
      estimate: [8, 32, 128, 256, 358.4, 716.8, 614.4, 1228.8, 1228.8, 737.28, 335.1272727272727, 335.1272727272727, 103.11608391608392, 29.46173826173826, 11.784695304695305, 5.892347652347652, 1.0398260562966446, 0.34660868543221485, 0.0364851247823384, 0.007297024956467681, 0.00104243213663824, 9.476655787620365e-05, 9.476655787620365e-05],
      real: [8, 32, 128, 256, 358, 716, 607, 1214, 1361, 863, 375, 375, 113, 35, 13, 8, 2, 0, 0, 0, 0, 0, 0]
    },
    26: {
      estimate: [12, 144, 528, 2904, 5808, 19360, 24891.4285714286, 56005.7142857143, 49782.8571428571, 79652.5714285714, 50688, 59136, 59136, 50688, 20275.2, 12672, 3727.05882352941, 1656.47058823529, 348.730650154799, 104.61919504644, 14.9455992923485, 2.71738168951791, 0.236294059958079, 0.019691171663173, 0.019691171663173],
      real: [12, 144, 528, 2904, 5784, 19298, 24824, 50734, 45186, 72245, 45974, 42962, 42962, 36799, 14746, 6216, 1839, 797, 174, 34, 6, 1, 0, 0, 0]
    },
    28: {
      estimate: [12, 72, 264, 1584, 3168, 5280, 10560, 26400, 26400, 21120, 15360, 20480, 11027.692307692309, 11027.692307692309, 4411.076923076923, 3308.3076923076924, 973.0316742081448, 324.3438914027149, 68.28292450583473, 27.31316980233389, 9.104389934111296, 1.6553436243838722, 0.2159143857892007, 0.035985730964866784, 0.002878858477189343, 0.0002214506520914879, 0.0002214506520914879],
      real: [12, 72, 264, 1584, 3177, 5291, 10582, 26432, 26472, 21196, 15395, 20362, 10866, 10866, 4390, 2576, 748, 236, 56, 20, 7, 2, 0, 0, 0, 0, 0]
    },
    30: {
      estimate: [8, 64, 256, 896, 1792, 7168, 7168, 10752, 10752, 21504, 11729.454545454546, 17594.18181818182, 6766.993006993007, 4833.566433566433, 4833.566433566433, 2416.7832167832166, 568.6548745372274, 379.10324969148496, 59.858407846023944, 29.929203923011972, 8.551201120860563, 2.3321457602346993, 0.2027952834986695, 0.05069882087466737, 0.010139764174933475, 0.0015599637192205346, 0.00017332930213561496, 1.2380664438258211e-05, 1.2380664438258211e-05],
      real: [8, 64, 256, 896, 1792, 7168, 7168, 9212, 10369, 20738, 11264, 16938, 6609, 4692, 4692, 1918, 455, 396, 49, 18, 4, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    32: {
      estimate: [16, 128, 640, 2560, 7168, 16725.333333333332, 31061.333333333332, 62122.666666666664, 82830.22222222222, 99396.26666666666, 99396.26666666666, 99396.26666666666, 76458.66666666667, 54613.333333333336, 32768, 32768, 15420.235294117647, 6853.437908496732, 2524.950808393533, 1009.9803233574131, 288.5658066735466, 78.6997654564218, 17.108644664439524, 5.702881554813174, 0.9124610487701078, 0.14037862288770891, 0.015597624765300988, 0.002228232109328713, 0.00015367117995370434, 1.0244745330246955e-05, 1.0244745330246955e-05],
      real: [16, 128, 640, 2560, 7162, 16730, 31103, 62206, 83016, 99747, 99803, 102336, 79000, 56561, 33721, 33721, 15901, 7103, 2645, 1062, 294, 73, 22, 4, 2, 1, 0, 0, 0, 0, 0]
    },
    34: {
      estimate: [16, 256, 1280, 9600, 26880, 125440, 232960, 757120, 1009493.33333333, 2422784, 2422784, 4441770.66666667, 3416746.66666667, 4881066.66666667, 2928640, 3294720, 3294720, 2928640, 1233111.57894737, 863178.105263158, 287726.035087719, 156941.473684211, 40941.2540045767, 17058.8558352403, 3411.77116704805, 1049.77574370709, 155.522332401051, 33.3262140859395, 3.44753938820064, 0.459671918426752, 0.029656252801726, 0.001853515800108, 0.001853515800108],
      real: [16, 256, 1284, 9630, 26964, 125816, 233756, 708916, 947471, 2270868, 2270016, 3527355, 2715611, 3872628, 2316289, 2022102, 2022102, 1802701, 759680, 355430, 118001, 64690, 16948, 3837, 791, 267, 39, 5, 2, 0, 0, 0, 0]
    },
    36: {
      estimate: [12, 72, 288, 1728, 3801.6, 7603.2, 10861.714285714286, 27154.285714285714, 54308.57142857143, 54308.57142857143, 44434.28571428572, 88868.57142857143, 54688.35164835165, 31250.48665620094, 18750.291993720566, 18750.291993720566, 7720.7084680025855, 7720.7084680025855, 2438.118463579764, 1462.8710781478583, 417.96316518510235, 113.98995414139156, 24.78042481334599, 12.390212406672996, 1.9824339850676793, 0.304989843856566, 0.10166328128552202, 0.029046651795863434, 0.0030048260478479413, 0.0006009652095695882, 3.877194900448957e-05, 4.846493625561196e-06, 4.405903295964723e-07, 2.5917078211557197e-08, 2.5917078211557197e-08],
      real: [12, 72, 288, 1728, 3796, 7592, 11352, 28380, 56760, 56738, 46672, 93344, 57205, 32717, 19066, 15264, 6316, 6316, 1996, 1165, 416, 110, 26, 11, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    38: {
      estimate: [18, 324, 1836, 15606, 49939.2, 266342.4, 570733.714285714, 2140251.42857143, 3329280, 9321984, 11016890.1818182, 23869928.7272727, 22033780.3636364, 37772194.9090909, 27699609.6, 38086963.2, 22404096, 24893440, 24893440, 22404096, 9601755.42857143, 6983094.85714286, 2428902.55900621, 1416859.82608696, 396720.751304348, 183101.885217391, 40689.307826087, 14531.8956521739, 2505.49925037481, 668.133133433283, 86.2107268946172, 16.1645112927407, 1.46950102661279, 0.172882473719152, 0.009878998498237, 0.000548833249902, 0.000548833249902],
      real: [18, 324, 1836, 15606, 49960, 266480, 571109, 2040294, 3166979, 8856586, 10464585, 19818844, 18251531, 31295318, 22925674, 25651486, 15088872, 16736367, 16736367, 10789785, 4618507, 3357221, 1167693, 426773, 119334, 54959, 12155, 2148, 381, 95, 12, 0, 0, 0, 0, 0, 0]
    },
    40: {
      estimate: [16, 128, 640, 2560, 10240, 23893.333333333332, 47786.666666666664, 191146.66666666666, 276100.74074074073, 552201.4814814815, 602401.6161616162, 602401.6161616162, 509724.44444444444, 436906.6666666667, 436906.6666666667, 655360, 385505.8823529412, 214169.93464052287, 101448.91640866874, 101448.91640866874, 38647.20625092142, 14053.529545789608, 4277.1611661098805, 2851.440777406587, 1140.5763109626348, 263.2099179144542, 58.491092869878706, 16.711740819965346, 2.881334624131956, 0.960444874710652, 0.12392837093040672, 0.03098209273260168, 0.0028165538847819706, 0.0003313592805625848, 4.733704008036926e-05, 5.259671120041029e-06, 2.8430654702924477e-07, 1.496350247522341e-08, 1.496350247522341e-08],
      real: [16, 128, 648, 2592, 10368, 22704, 45430, 181720, 265682, 531364, 579550, 545470, 463296, 397060, 390323, 585786, 344716, 188046, 89148, 89148, 36302, 13060, 3898, 2486, 922, 218, 46, 15, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    42: {
      estimate: [12, 144, 864, 4752, 10454.4, 62726.4, 125452.8, 313632, 522720, 940896, 855360, 2138400, 1480430.7692307692, 2960861.5384615385, 2368689.230769231, 2368689.230769231, 1114677.2850678733, 1486236.3800904977, 547560.7716122887, 383292.54012860206, 383292.54012860206, 209068.65825196475, 54539.649978773414, 40904.73748408006, 8180.947496816012, 3146.5182680061585, 1048.8394226687194, 524.4197113343597, 72.3337532874979, 28.93350131499916, 2.8000162562902413, 0.7000040640725603, 0.12727346619501095, 0.022460023446178406, 0.004492004689235681, 0.0007486674482059468, 4.0468510713834964e-05, 4.259843233035259e-06, 3.2768024869501995e-07, 1.6384012434751e-08, 1.6384012434751e-08],
      real: [12, 144, 864, 4752, 10454, 62724, 125448, 380136, 633432, 1150848, 1045808, 2607283, 1806590, 3613180, 2868490, 2422167, 1140588, 1522857, 561079, 262409, 262409, 142577, 37306, 24262, 4875, 1867, 630, 214, 36, 9, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    44: {
      estimate: [20, 200, 1266.6666666666667, 12666.666666666666, 45600, 136800, 332228.5714285714, 1495028.5714285714, 2657828.5714285714, 4252525.714285715, 8505051.42857143, 22680137.14285714, 26169389.01098901, 26169389.01098901, 24424763.076923076, 42743335.384615384, 32686080, 21790720, 13762560, 16515072, 8650752, 8650752, 3761196.5217391304, 3134330.434782609, 1128358.956521739, 433984.21404682274, 128587.91527313266, 73478.80872750438, 17736.264175604505, 4729.670446827869, 915.4200864828132, 343.28253243105496, 114.42751081035165, 20.193090143003232, 2.884727163286176, 0.6410504807302614, 0.06930275467354177, 0.007295026807741238, 0.0005611559082877876, 5.611559082877876e-05, 2.7373458940867686e-06, 1.3034980448032232e-07, 1.3034980448032232e-07],
      real: [20, 200, 1268, 12680, 45648, 137238, 333228, 1500492, 2661954, 4272305, 8544610, 22471026, 25929972, 25935734, 24247761, 37658988, 28788781, 19089608, 12052445, 14466612, 7574019, 7574019, 3292303, 2063548, 744507, 286103, 84435, 48208, 11655, 3137, 615, 138, 46, 9, 1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    46: {
      estimate: [22, 484, 3388, 35574, 142296, 948640, 2574880, 12230680, 24461360, 88060896, 136094112, 385599984, 474584595.6923077, 1084764790.1538463, 1084764790.1538463, 2033933981.5384614, 1675004455.3846154, 2605562486.1538463, 1782753280, 2317579264, 1324331008, 1444724736, 1444724736, 1324331008, 582705643.52, 448235110.4, 166013003.85185185, 106722645.33333333, 33120820.96551724, 17664437.848275863, 4558564.6060066745, 1994372.0151279198, 423048.60926955874, 149311.27385984428, 25596.218375973305, 7110.060659992584, 960.819008107106, 202.27768591728548, 20.746429324849792, 3.1119643987274688, 0.2277047121020099, 0.021686163057334278, 0.001008658746852757, 4.58481248569435e-05, 4.58481248569435e-05],
      real: [22, 484, 3392, 35616, 142460, 949576, 2577205, 11754411, 23557289, 84327419, 130324833, 332092243, 408733458, 934277218, 934646372, 1487019411, 1224620237, 1902493038, 1301653846, 1314436609, 750811935, 819064146, 819064146, 494408126, 217663449, 167422124, 61999099, 24957258, 7745648, 4114404, 1062173, 252581, 53470, 18738, 3191, 365, 54, 6, 2, 0, 0, 0, 0, 0, 0]
    },
    48: {
      estimate: [16, 128, 1024, 4096, 12288, 49152, 98304, 196608, 458752, 642252.8, 759026.0363636364, 1518052.0727272728, 1401278.8363636364, 1201096.1454545455, 1441315.3745454545, 2882630.749090909, 1865231.6611764706, 1865231.6611764706, 981700.8743034055, 589020.5245820433, 420728.94613003096, 191240.43005910498, 74833.21176225848, 74833.21176225848, 23946.627763922712, 7368.193158130065, 3274.7525147244733, 935.6435756355638, 225.8450010154809, 90.33800040619236, 17.484774272166263, 8.742387136083131, 2.3842874007499453, 0.4207566001323433, 0.060108085733191895, 0.02003602857773063, 0.0021660571435384466, 0.00022800601510931018, 3.5077848478355416e-05, 7.015569695671082e-06, 5.133343679759329e-07, 7.333348113941899e-08, 3.4108595878799526e-09, 3.1007814435272294e-10, 2.0671876290181533e-11, 8.987772300078926e-13, 8.987772300078926e-13],
      real: [16, 128, 1024, 4096, 12288, 49152, 98304, 196608, 430048, 603232, 713064, 1426128, 1315303, 1127547, 1351591, 2703182, 1749035, 1970294, 1037294, 603082, 430605, 195790, 76547, 76547, 24430, 7449, 2715, 727, 162, 66, 9, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    50: {
      estimate: [20, 400, 2533.3333333333335, 24066.666666666668, 96266.66666666667, 577600, 1485257.142857143, 6312342.857142857, 11923314.285714285, 47693257.14285714, 69372010.3896104, 184992027.7056277, 213452339.66033965, 457397870.7007278, 457397870.7007278, 800446273.7262738, 659191048.951049, 952164848.4848485, 651481212.1212121, 977221818.1818181, 558412467.5324675, 609177237.3081464, 291345635.2343309, 267066832.29813665, 267066832.29813665, 205436024.84472048, 76087416.60915574, 48913339.248742975, 15180001.835816786, 10120001.223877857, 2611613.2190652536, 1305806.6095326268, 276989.28080995113, 114054.409745274, 32586.974212935427, 10862.324737645142, 1761.458065564077, 463.54159620107293, 59.42840976936832, 14.85710244234208, 1.4494734090089836, 0.2760901731445683, 0.019262105103109415, 0.0026266506958785565, 0.0002918500773198396, 2.5378267593029532e-05, 1.0799262805544481e-06, 4.499692835643534e-08, 4.499692835643534e-08],
      real: [20, 400, 2534, 24072, 96288, 579252, 1489420, 5997462, 11337794, 45351176, 65965520, 155928495, 179920811, 385548524, 384979973, 540776890, 445268608, 642827854, 439827685, 661399749, 375949079, 410126330, 196135485, 134319388, 134319388, 103338440, 38304441, 16246879, 5041703, 3351975, 865683, 249778, 53178, 21827, 6321, 926, 145, 44, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    52: {
      estimate: [24, 288, 2208, 26496, 116582.4, 427468.8, 1282406.4, 7053235.2, 15673856, 31347712, 54146048, 180486826.66666666, 360973653.3333333, 464108982.85714287, 556930779.4285715, 1253094253.7142856, 1253094253.7142856, 1113861558.857143, 937988681.1428572, 1500781889.8285713, 1071987064.1632653, 682173586.2857143, 415236096, 484442112, 251909898.24, 251909898.24, 111959954.77333333, 95965675.52, 36400773.47310345, 14560309.389241379, 4696873.996529478, 2935546.247830923, 800603.5221357064, 235471.6241575607, 53822.08552172816, 23920.926898545848, 4525.580764589755, 952.7538451767905, 317.5846150589302, 95.27538451767906, 13.94273919770913, 1.9918198853870186, 0.23160696341709516, 0.0421103569849264, 0.0037431428431045684, 0.0003254906820090929, 2.0776000979303802e-05, 1.7313334149419836e-06, 7.066666999763199e-08, 2.8266667999052795e-09, 2.8266667999052795e-09],
      real: [24, 288, 2208, 26496, 116589, 427513, 1281625, 7049130, 15664380, 31339162, 54129972, 180302048, 360604096, 463676511, 556281572, 1138024650, 1138043672, 1010306125, 850765597, 1360876851, 971806139, 618582796, 376546534, 350689202, 182336192, 182336192, 81027145, 69442398, 26338387, 10491527, 3386425, 1502708, 410142, 120874, 27704, 12255, 2380, 486, 159, 18, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    54: {
      estimate: [18, 324, 1944, 16524, 56181.6, 337089.6, 770490.5142857142, 3081962.057142857, 6163924.114285714, 18491772.34285714, 25216053.194805194, 63040132.98701299, 67889373.98601398, 135778747.97202796, 135778747.97202796, 220640465.45454547, 168725061.8181818, 337450123.6363636, 213126393.87559807, 255751672.6507177, 146143812.94326726, 146143812.94326726, 69894867.05982347, 69894867.05982347, 27957946.823929388, 21506112.941484146, 21506112.941484146, 13825358.319525521, 4290628.443990679, 2574377.0663944073, 664355.3719727503, 332177.68598637515, 90593.9143599205, 37303.376501143735, 7460.675300228747, 3730.3376501143734, 604.919618937466, 191.02724808551557, 29.388807397771625, 7.347201849442906, 0.8960002255418179, 0.25600006444051937, 0.023813959482839014, 0.004329810815061639, 0.0008659621630123278, 0.00011295158647986883, 7.209675732757585e-06, 9.012094665946981e-07, 3.678405986100809e-08, 2.9427247888806468e-09, 1.7310145816944984e-10, 6.6577483911326855e-12, 6.6577483911326855e-12],
      real: [18, 324, 1944, 16524, 56184, 337104, 770512, 2936522, 5873044, 17620835, 24028359, 60060258, 64678803, 129362154, 129361916, 177878559, 136020337, 272040674, 171801777, 164904543, 94140795, 94152344, 45027629, 34780944, 13909431, 10701303, 10701303, 4911966, 1523000, 913904, 235488, 73904, 20101, 8224, 1660, 805, 135, 45, 7, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    56: {
      estimate: [24, 288, 2208, 13248, 58291.2, 213734.4, 854937.6, 5129625.6, 11969126.4, 23938252.8, 43524096, 72540160, 106020233.84615384, 212040467.69230768, 254448561.23076922, 636121403.0769231, 636121403.0769231, 636121403.0769231, 535681181.53846157, 428544945.2307692, 428544945.2307692, 311669051.0769231, 203262424.6153846, 271016566.15384614, 151769277.04615384, 81721918.40946746, 39347590.34529915, 39347590.34529915, 16281761.52219275, 6512704.6088771, 2310959.6999241323, 1733219.7749430991, 525218.1136191209, 154475.91577032968, 61790.36630813188, 20596.788769377294, 5010.029700659342, 1054.7430948756507, 216.35755792321044, 86.54302316928417, 14.775638102072907, 4.925212700690969, 0.6872389814917631, 0.12495254208941148, 0.013883615787712385, 0.00181090640709292, 0.00015411969422067404, 2.568661570344567e-05, 3.6695165290636676e-06, 2.9356132232509344e-07, 1.7268313077946672e-08, 1.328331775226667e-09, 5.012572736704404e-11, 1.856508421001631e-12, 1.856508421001631e-12],
      real: [24, 288, 2208, 13248, 58290, 213732, 854928, 5129568, 11969528, 23936850, 43641092, 72625359, 106142029, 212284058, 254898923, 637345126, 637340344, 637370281, 536792638, 428715360, 428653196, 311532533, 203163929, 270465806, 151474489, 81560239, 39243095, 39243095, 16235726, 6497720, 2305862, 1385955, 416328, 122581, 48894, 16379, 4011, 834, 168, 63, 17, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
  }

  let base = 32
  let fixedMax = false

  const baseInput = getEl('chart-base')
  const baseWrap = getEl('base-wrap')
  const maximumInput = getEl('chart-maximum')

  const applyMaximum = () => {
    const value = +maximumInput.value.replace(/\D/g, '').slice(0, 10)

    if (value) {
      if (!fixedMax && value === max) {
        return
      }

      fixedMax = value
    } else {
      fixedMax = false
    }

    updateChart()
  }

  maximumInput.addEventListener('keydown', ev => {
    switch (ev.keyCode) {
      case 13:
        ev.preventDefault()
        applyMaximum()
        break;
      case 27:
        ev.stopPropagation()
        ev.preventDefault()
        fixedMax = false
        updateChart()
        break;
    }
  })

  maximumInput.addEventListener('blur', applyMaximum)

  baseInput.addEventListener('blur', () => {
    baseInput.value = base
  })

  const applyDelta = delta => {
    const value = base + delta

    if (dataSets[value]) {
      base = baseInput.value = value
      updateChart()
    }
  }

  baseWrap.addEventListener('keydown', ev => {
    let delta = 0

    switch (ev.keyCode) {
      case 38:
        delta = 2
        break
      case 40:
        delta = -2
        break
    }

    if (delta) {
      ev.preventDefault()

      applyDelta(delta)
    }
  })

  const baseUp = getEl('base-up')
  const baseDown = getEl('base-down')

  baseUp.addEventListener('click', () => {
    applyDelta(2)
  })

  baseDown.addEventListener('click', () => {
    applyDelta(-2)
  })

  baseInput.addEventListener('input', () => {
    const value = baseInput.value.trim()

    if (/^\d\d$/.test(value) && dataSets[value]) {
      base = +value
      updateChart()
    }
  })

  const chart = getEl('chart')

  const verticalLines = createVerticalLines()

  const axes = createElement('polyline', {
    class: 'axes'
  })

  chart.appendChild(axes)

  const realLine = createLine({
    seriesClass: 'series-1'
  })

  const estimateLine = createLine({
    seriesClass: 'series-2'
  })

  const legendSelected = getEl('legend-selected')
  const selectedK = getEl('selected-k')
  const selectedE = getEl('selected-e')
  const selectedR = getEl('selected-r')

  const regions = createRegions(index => {
    if (index == null) {
      legendSelected.style.display = 'none'
      return
    }

    legendSelected.style.display = 'block'

    selectedK.innerHTML = index + 1
    selectedE.innerHTML = format(dataSets[base].estimate[index])
    selectedR.innerHTML = dataSets[base].real[index]

    function format (num) {
      if (num === Math.round(num)) {
        return num
      }

      let multiplier = 1

      for (let dp = 1; dp <= 4; ++dp) {
        if (num * multiplier >= 10) {
          return num.toFixed(dp)
        }

        multiplier *= 10
      }

      let exp = 3

      while (num * (10 ** exp) < 1) {
        exp += 1
      }

      return (num * (10 ** exp)).toFixed(2) + 'e-' + exp
    }
  })

  // TODO: Hack
  let max = 0
  let length = 0
  let chartSize = null

  updateSize()

  window.addEventListener('resize', () => {
    updateSize()
  })

  const fullButton = getEl('full-button')
  const chartWrapper = getEl('chart-wrapper')

  fullButton.addEventListener('click', () => {
    if (chartWrapper.className.includes('full-page')) {
      exitFullPage()
    } else {
      chartWrapper.className += ' full-page'
      updateSize()
    }
  })

  document.addEventListener('keydown', ev => {
    if (ev.keyCode === 27) {
      exitFullPage()
    }
  })

  const estimateCheckbox = getEl('estimate-checkbox')

  estimateCheckbox.addEventListener('input', () => {
    estimateLine.setVisible(estimateCheckbox.checked)
  })

  const realCheckbox = getEl('real-checkbox')

  realCheckbox.addEventListener('input', () => {
    realLine.setVisible(realCheckbox.checked)
  })

  function exitFullPage() {
    chartWrapper.className = chartWrapper.className.split(/\s+/).filter(cls => cls && cls !== 'full-page').join(' ')
    updateSize()
  }

  function updateSize() {
    const { width, height } = chart.getBoundingClientRect()
    const margin = Math.ceil(width * 0.025)

    chart.setAttribute('viewBox', `${-margin} ${-margin} ${width} ${height}`)

    chartSize = {
      height: height - 2 * margin,
      width: width - 2 * margin
    }

    axes.setAttribute('points', `0,0 0,${chartSize.height} ${chartSize.width},${chartSize.height}`)

    updateChart()
  }

  function updateChart() {
    const data1 = dataSets[base].real
    const data2 = dataSets[base].estimate

    length = Math.max(data1.length, data2.length)

    if (fixedMax) {
      max = fixedMax
    } else {
      max = Math.ceil(Math.max(...data1, ...data2))
    }

    maximumInput.value = max

    verticalLines.refresh()
    realLine.setData(data1)
    estimateLine.setData(data2)
    regions.refresh()
  }

  function createElement(tag, attributes) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', tag)

    for (const name in attributes) {
      el.setAttribute(name.replace(/([A-Z])/g, '-$1').toLowerCase(), String(attributes[name]))
    }

    return el
  }

  function createLine({ seriesClass }) {
    const polyLine = createElement('polyline', {
      class: `series-line ${seriesClass}`
    })

    let transition = null
    let frame = null
    let frameId = null

    chart.appendChild(polyLine)

    return {
      setData (data) {
        const points = data.map((value, index) => {
          // TODO: length & max are coming from the closure
          const x = index / (length - 1)

          // Math.max is required to avoid crazy values when the axis scale is set manually
          const y = Math.max(-1, 1 - value / max)

          return { x, y, digit: index + 1, value }
        })

        let newTransition = points.map(point => {
          const { y } = point

          return {
            ...point,
            startY: y,
            endY: y,
            transitional: false
          }
        })

        if (transition) {
          const extraPoints = transition.filter(point => !(point.transitional && point.y === point.endY))

          for (const point of extraPoints) {
            point.transitional = true
          }

          newTransition.push(...extraPoints)

          newTransition.sort((point1, point2) => (point1.x - point2.x) || point1.transitional - point2.transitional)

          let lastX = null
          const filteredTransition = []

          for (const point of newTransition) {
            if (point.x !== lastX) {
              filteredTransition.push(point)
            }

            lastX = point.x
          }

          newTransition = filteredTransition

          for (const point of newTransition) {
            point.y = point.startY = valueAt(extraPoints, point.x)
            point.endY = valueAt(points, point.x)
          }
        }

        transition = newTransition

        updatePoints()

        frame = 0

        if (frameId) {
          cancelAnimationFrame(frameId)
        }

        frameId = requestAnimationFrame(function tick() {
          for (const point of transition) {
            if (point.endY !== point.y) {
              point.y = point.startY + (frame / 20) * (point.endY - point.startY)
            }
          }

          updatePoints()

          ++frame

          if (frame < 21) {
            frameId = requestAnimationFrame(tick)
          }
        })

        function updatePoints() {
          const xys = transition.map(({ x, y }) => `${(x * chartSize.width).toFixed(1)},${(y * chartSize.height).toFixed(1)}`).join(' ')

          polyLine.setAttribute('points', xys)
        }
      },

      setVisible (visible) {
        polyLine.style.display = visible ? '' : 'none'
      }
    }
  }

  function createVerticalLines () {
    const group = createElement('g')

    chart.appendChild(group)

    return {
      refresh() {
        group.innerHTML = ''

        const regionWidth = chartSize.width / (length - 1)

        for (let index = 1; index < length; ++index) {
          const x = Math.floor(index * regionWidth) + 0.5

          const line = createElement('line', {
            class: 'vertical-line',
            x1: x,
            x2: x,
            y1: -4,
            y2: chartSize.height + 4,
          })

          group.appendChild(line)
        }
      }
    }
  }

  function createRegions (callback) {
    const group = createElement('g')

    chart.appendChild(group)

    let currentSelection = null
    const regions = []

    return {
      refresh () {
        this.setSelection(null)

        group.innerHTML = ''
        regions.length = 0

        const regionWidth = chartSize.width / (length - 1)

        for (let index = 0; index < length; ++index) {
          const region = createElement('rect', {
            class: 'chart-region',
            width: Math.ceil(regionWidth),
            height: chartSize.height + 8,
            x: Math.round((index - 0.5) * regionWidth),
            y: -4
          })

          region.addEventListener('click', () => {
            this.setSelection(region === currentSelection ? null : region)
          })

          group.appendChild(region)

          regions.push(region)
        }
      },

      setSelection (selection) {
        if (currentSelection) {
          currentSelection.setAttribute('class', 'chart-region')
          currentSelection = null
        }

        let index = null

        if (selection != null) {
          currentSelection = selection
          currentSelection.setAttribute('class', 'chart-region selected')
          index = regions.indexOf(selection)
        }

        callback(index)
      }
    }
  }

  function valueAt(points, x) {
    for (let index = 0; index < points.length; ++index) {
      const { x: x2, y: y2 } = points[index]

      if (x2 === x) {
        return y2
      }

      if (x2 > x) {
        const { x: x1, y: y1 } = points[index - 1]

        return y1 + (y2 - y1) * (x - x1) / (x2 - x1)
      }
    }
  }

  function getEl(cls) {
    return document.querySelector('#demo-1 .' + cls)
  }
})()
